// extracted by mini-css-extract-plugin
export default {"controlerAndFilter":"swipeContainer_controlerAndFilter__GNKDl","viewStyle":"swipeContainer_viewStyle__TW6j6"};